module.exports = "/images/skipback.svg?bdd9291a4c1df2a185bc04c533666bc9";